import React, { useContext, useState, useEffect, useRef, forwardRef } from "react";
import { useHistory } from "react-router-dom";

import { Can } from "../Can";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { IconButton, Menu } from "@material-ui/core";
import { DeviceHubOutlined, History, MoreVert, PictureAsPdf, Replay } from "@material-ui/icons";
import { v4 as uuidv4 } from "uuid";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
// import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmationModal from "../ConfirmationModal";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import Button from '@material-ui/core/Button';
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";

// Custom SVG Icons
const TranslateIcon = forwardRef((props, ref) => (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
        <circle cx="12" cy="12" r="10" />
        <path d="M7 8.37931H11.5M17 8.37931H14.5M11.5 8.37931H14.5M11.5 8.37931V7M14.5 8.37931C13.9725 10.2656 12.8679 12.0487 11.6071 13.6158M8.39286 17C9.41205 16.0628 10.5631 14.9134 11.6071 13.6158M11.6071 13.6158C10.9643 12.8621 10.0643 11.6426 9.80714 11.0909M11.6071 13.6158L13.5357 15.6207" />
    </svg>
));
const ResolveIcon = forwardRef((props, ref) => (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M15 2L18.5 5.5M18.5 5.5L22 9M18.5 5.5L22 2M18.5 5.5L15 9" />
        <path d="M6.09881 19.5C4.7987 19.3721 3.82475 18.9816 3.17157 18.3284C2 17.1569 2 15.2712 2 11.5V11C2 7.22876 2 5.34315 3.17157 4.17157C4.34315 3 6.22876 3 10 3H11.5M6.5 18C6.29454 19.0019 5.37769 21.1665 6.31569 21.8651C6.806 22.2218 7.58729 21.8408 9.14987 21.0789C10.2465 20.5441 11.3562 19.9309 12.5546 19.655C12.9931 19.5551 13.4395 19.5125 14 19.5C17.7712 19.5 19.6569 19.5 20.8284 18.3284C21.947 17.2098 21.9976 15.4403 21.9999 12" />
    </svg>
));
const ReturnQueueIcon = forwardRef((props, ref) => (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M20 21V18.9231C20 16.9221 20 15.9217 19.8547 15.0846C19.0547 10.4765 15.0934 6.86243 10.0426 6.13259C9.12509 6 7.19318 6 5 6" />
        <path d="M7 3C6.39316 3.58984 4 5.15973 4 6C4 6.84027 6.39316 8.41016 7 9" />
    </svg>
));
const TransferTicketIcon = forwardRef((props, ref) => (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M9 19L18.1795 9.9942C18.9276 9.26025 19.3016 8.89327 19.6243 9.02718C19.9469 9.16108 19.9526 9.68566 19.964 10.7348L20 14.0459" />
        <path d="M15 5L5.82055 14.0058C5.07244 14.7398 4.69839 15.1067 4.37573 14.9728C4.05306 14.8389 4.04736 14.3143 4.03597 13.2652L4 9.95414" />
    </svg>
));

import ScheduleModal from "../ScheduleModal";
import MenuItem from "@material-ui/core/MenuItem";
import { Switch } from "@material-ui/core";
import ShowTicketOpen from "../ShowTicketOpenModal";
import { toast } from "react-toastify";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import ShowTicketLogModal from "../ShowTicketLogModal";
import TicketMessagesDialog from "../TicketMessagesDialog";
import { useTheme } from "@material-ui/styles";
import AiSummaryModal from "../AiSummaryModal";
import ContactHistoryModal from "../ContactHistoryModal";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";

// AI Summary Icon
const AiSummaryIcon = forwardRef((props, ref) => (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M11 21H10C6.22876 21 4.34315 21 3.17157 19.8284C2 18.6569 2 16.7712 2 13V10C2 6.22876 2 4.34315 3.17157 3.17157C4.34315 2 6.22876 2 10 2H12C15.7712 2 17.6569 2 18.8284 3.17157C20 4.34315 20 6.22876 20 10V10.5" />
        <path d="M17.4069 14.4036C17.6192 13.8655 18.3808 13.8655 18.5931 14.4036L18.6298 14.4969C19.1482 15.8113 20.1887 16.8518 21.5031 17.3702L21.5964 17.4069C22.1345 17.6192 22.1345 18.3808 21.5964 18.5931L21.5031 18.6298C20.1887 19.1482 19.1482 20.1887 18.6298 21.5031L18.5931 21.5964C18.3808 22.1345 17.6192 22.1345 17.4069 21.5964L17.3702 21.5031C16.8518 20.1887 15.8113 19.1482 14.4969 18.6298L14.4036 18.5931C13.8655 18.3808 13.8655 17.6192 14.4036 17.4069L14.4969 17.3702C15.8113 16.8518 16.8518 15.8113 17.3702 14.4969L17.4069 14.4036Z" />
        <path d="M7 7H15M7 11.5H15M7 16H11" />
    </svg>
));

const ChatHeaderSwitch = withStyles((theme) => {
    const isDark = theme.mode === "dark" || theme.palette?.type === "dark" || theme.palette?.mode === "dark";

    return {
        root: {
            width: 40,
            height: 22,
            padding: 0,
            display: "flex",
        },
        switchBase: {
            padding: 2,
            color: isDark ? "#EEF6FF" : "#ffffff",
            "&$checked": {
                transform: "translateX(18px)",
                color: "#ffffff",
                "& + $track": {
                    opacity: 1,
                    backgroundColor: "#4CAF50",
                    borderColor: "#4CAF50",
                },
            },
        },
        thumb: {
            width: 18,
            height: 18,
            boxShadow: isDark ? "0 1px 6px rgba(0,0,0,0.45)" : "0 1px 4px rgba(0,0,0,0.2)",
        },
        track: {
            borderRadius: 11,
            opacity: 1,
            backgroundColor: isDark ? "#5E7893" : "#9FB3C8",
            border: isDark ? "1px solid rgba(214, 231, 248, 0.45)" : "1px solid rgba(22, 49, 73, 0.25)",
            boxSizing: "border-box",
        },
        checked: {},
    };
})(Switch);

const useStyles = makeStyles(theme => ({
    "@keyframes pulseHistoryReminder": {
        "0%": {
            transform: "scale(1)",
            boxShadow: "0 0 0 0 rgba(255, 152, 0, 0.45)",
            opacity: 1,
        },
        "70%": {
            transform: "scale(1.04)",
            boxShadow: "0 0 0 10px rgba(255, 152, 0, 0)",
            opacity: 1,
        },
        "100%": {
            transform: "scale(1)",
            boxShadow: "0 0 0 0 rgba(255, 152, 0, 0)",
            opacity: 0.95,
        },
    },
    actionButtons: {
        marginRight: 6,
        maxWidth: "100%",
        flex: "none",
        alignSelf: "center",
        marginLeft: "auto",
        display: "flex",
        alignItems: "center",
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    historyReminderWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
        padding: "2px 6px 2px 2px",
        cursor: "pointer",
        borderRadius: 999,
        background: theme.palette.type === "dark"
            ? "rgba(255, 152, 0, 0.16)"
            : "rgba(255, 152, 0, 0.12)",
        border: "1px solid rgba(255, 152, 0, 0.35)",
        animation: "$pulseHistoryReminder 1.5s infinite",
    },
    historyReminderText: {
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        color: theme.palette.type === "dark" ? "#FFD180" : "#9A4D00",
        whiteSpace: "nowrap",
    },
    historyReminderButton: {
        color: "#ff9800",
    },
    bottomButtonVisibilityIcon: {
        padding: 1,
        color: theme.mode === "light" ? '#0872b9' : '#FFF',
    },
    botoes: {
        display: "flex",
        padding: "15px",
        justifyContent: "flex-end",
        maxWidth: "100%",
        // alignItems: "center"

    },
    closeDialogContent: {
        minWidth: 520,
        maxWidth: 680,
        paddingTop: theme.spacing(2),
    },
    closeDialogHeader: {
        marginBottom: theme.spacing(1.5),
    },
    closeSummaryCard: {
        borderRadius: 12,
        padding: theme.spacing(2),
        background: theme.palette.type === "dark"
            ? "linear-gradient(135deg, rgba(88,84,186,0.16) 0%, rgba(38,47,71,0.55) 100%)"
            : "linear-gradient(135deg, rgba(107,70,193,0.07) 0%, rgba(22,49,73,0.04) 100%)",
        border: `1px solid ${theme.palette.divider}`,
        marginBottom: theme.spacing(1.5),
    },
    closeSummaryMeta: {
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(1),
        alignItems: "center",
        marginBottom: theme.spacing(1),
        flexWrap: "wrap",
    },
    closeSummaryText: {
        whiteSpace: "pre-wrap",
        lineHeight: 1.55,
        fontSize: "0.9rem",
    },
    closeSummaryActions: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: theme.spacing(1.5),
    },
    closeSummaryEmpty: {
        padding: theme.spacing(2),
        borderRadius: 12,
        border: `1px dashed ${theme.palette.divider}`,
        marginBottom: theme.spacing(1.5),
    }
}));

const SessionSchema = Yup.object().shape({
    ratingId: Yup.string().required(i18n.t("validationResponsive.ratingRequired")),
});

const TicketActionButtonsCustom = ({ ticket, onTicketUpdated
    // , showSelectMessageCheckbox,
    // selectedMessages,
    // forwardMessageModalOpen,
    // setForwardMessageModalOpen
}) => {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const [isMounted, setIsMounted] = useState(true);
    const [loading, setLoading] = useState(false);
    const { user } = useContext(AuthContext);
    const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
    const [open, setOpen] = React.useState(false);
    const formRef = React.useRef(null);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
    const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
    const [contactId, setContactId] = useState(null);
    const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);
    const [showTicketLogOpen, setShowTicketLogOpen] = useState(false);
    const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
    const [disableBot, setDisableBot] = useState(ticket.contact.disableBot);
    const [contactTranslate, setContactTranslate] = useState(!!ticket.contact.language);

    const [showSchedules, setShowSchedules] = useState(false);
    const [enableIntegration, setEnableIntegration] = useState(ticket.useIntegration);

    const [openAlert, setOpenAlert] = useState(false);
    const [userTicketOpen, setUserTicketOpen] = useState("");
    const [queueTicketOpen, setQueueTicketOpen] = useState("");
    const [aiSummaryModalOpen, setAiSummaryModalOpen] = useState(false);
    const [contactHistoryOpen, setContactHistoryOpen] = useState(false);
    const [hasContactHistory, setHasContactHistory] = useState(Boolean(ticket?.contact?.hasHistory));
    const [bitacoraCloseGuardOpen, setBitacoraCloseGuardOpen] = useState(false);
    const [resumeCloseAfterHistory, setResumeCloseAfterHistory] = useState(false);
    const lastHistoryReminderToastTicketIdRef = useRef(null);
    const [logTicket, setLogTicket] = useState([]);
    const [latestCloseSummary, setLatestCloseSummary] = useState(null);
    const [loadingCloseSummary, setLoadingCloseSummary] = useState(false);
    const [generatingCloseSummary, setGeneratingCloseSummary] = useState(false);

    const { get: getSetting } = useCompanySettings()
    const { getPlanCompany } = usePlans();


    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        fetchData();

        // Cleanup function to set isMounted to false when the component unmounts
        return () => {
            setIsMounted(false);
        };
    }, []);

    useEffect(() => {
        setHasContactHistory(Boolean(ticket?.contact?.hasHistory));
    }, [ticket?.contact?.id, ticket?.contact?.hasHistory]);

    const normalizeReminderValue = (value) =>
        String(value || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim()
            .toUpperCase();

    const contactIsBitacoraExempt = (() => {
        const name = normalizeReminderValue(ticket?.contact?.name);
        const number = String(ticket?.contact?.number || "").replace(/\D/g, "");
        return name === "FACIL WEB" || number === "573209481569";
    })();

    const needsHistoryReminder =
        (ticket.status === "open" || ticket.status === "group") &&
        !contactIsBitacoraExempt &&
        !hasContactHistory;

    useEffect(() => {
        if (!needsHistoryReminder || !ticket?.id) {
            return;
        }

        if (lastHistoryReminderToastTicketIdRef.current === ticket.id) {
            return;
        }

        lastHistoryReminderToastTicketIdRef.current = ticket.id;
        toast.info("Recuerde crear la bitacora inicial de este contacto.", {
            toastId: `contact-history-reminder-${ticket.id}`,
            autoClose: 5000
        });
    }, [needsHistoryReminder, ticket?.id]);


    const fetchData = async () => {
        const companyId = user.companyId;
        const planConfigs = await getPlanCompany(undefined, companyId);
        if (planConfigs && planConfigs.plan) {
            setShowSchedules(planConfigs.plan.useSchedules);
        }
        setOpenTicketMessageDialog(false);
        setDisableBot(ticket.contact.disableBot)

        setShowTicketLogOpen(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    const refreshContactHistoryState = async () => {
        if (!ticket?.contact?.id) {
            return false;
        }

        try {
            const { data } = await api.get(`/contacts/${ticket.contact.id}`);
            const nextHasHistory = Boolean(data?.hasHistory);
            setHasContactHistory(nextHasHistory);
            if (ticket.contact) {
                ticket.contact.hasHistory = nextHasHistory;
            }
            return nextHasHistory;
        } catch (err) {
            toastError(err);
            // Keep the action protected when the check cannot be completed.
            return false;
        }
    };

    const handleCloseContactHistory = async () => {
        setContactHistoryOpen(false);
        await refreshContactHistoryState();

        if (resumeCloseAfterHistory) {
            setResumeCloseAfterHistory(false);
            setOpen(true);
        }
    };

    const handleRequestTicketClose = async (event, sendFarewellMessage) => {
        // The ticket may have been open while its contact history changed elsewhere.
        // Read the source of truth before allowing any manual close action.
        const hasCurrentContactHistory = await refreshContactHistoryState();
        const mustCreateInitialHistory =
            (ticket.status === "open" || ticket.status === "group") &&
            !contactIsBitacoraExempt &&
            !hasCurrentContactHistory;

        if (mustCreateInitialHistory) {
            setResumeCloseAfterHistory(true);
            setBitacoraCloseGuardOpen(true);
            return;
        }

        if (sendFarewellMessage) {
            await handleUpdateTicketStatus(event, "closed", user?.id, ticket?.queue?.id);
            return;
        }

        await handleCloseTicketWithoutFarewellMsg();
    };

    const handleCreateRequiredHistory = () => {
        setBitacoraCloseGuardOpen(false);
        setOpen(false);
        setContactHistoryOpen(true);
    };

    const handleClickOpen = async (e) => {
        const setting = await getSetting({
            "column": "requiredTag"
        });

        if (setting?.requiredTag === "enabled") {
            //verificar se tem uma tag   
            try {
                const contactTags = await api.get(`/contactTags/${ticket.contact.id}`);
                if (!contactTags.data.tags) {
                    toast.warning(i18n.t("messagesList.header.buttons.requiredTag"))
                } else {
                    loadLatestCloseSummary();
                    setOpen(true);
                    // handleUpdateTicketStatus(e, "closed", user?.id);
                }
            } catch (err) {
                toastError(err);
            }
        } else {

            loadLatestCloseSummary();
            setOpen(true);
            // handleUpdateTicketStatus(e, "closed", user?.id);
        }
    };

    const handleClose = () => {
        formRef.current.resetForm();
        setOpen(false);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
        setLoading(false);
    };

    const loadLatestCloseSummary = async () => {
        setLoadingCloseSummary(true);
        try {
            const { data } = await api.get(`/tickets/${ticket.id}/ai-summaries`);
            const summaries = Array.isArray(data) ? data : [];
            setLatestCloseSummary(summaries.length ? summaries[0] : null);
        } catch (err) {
            setLatestCloseSummary(null);
            toastError(err);
        } finally {
            setLoadingCloseSummary(false);
        }
    };

    const handleGenerateCloseSummary = async () => {
        setGeneratingCloseSummary(true);
        try {
            const { data } = await api.post(`/tickets/${ticket.id}/ai-summaries`);
            setLatestCloseSummary(data || null);
            toast.success("Resumen IA actualizado para apoyar el cierre.");
        } catch (err) {
            const message = err?.response?.data?.error || err?.response?.data?.message || "";
            if (String(message).toLowerCase().includes("no hay mensajes nuevos")) {
                toast.info("No hay mensajes nuevos desde el ultimo resumen. Se conserva el resumen mas reciente.");
                await loadLatestCloseSummary();
            } else {
                toastError(err);
            }
        } finally {
            setGeneratingCloseSummary(false);
        }
    };
    const handleOpenAcceptTicketWithouSelectQueue = async () => {

        setAcceptTicketWithouSelectQueueOpen(true);

    };

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(true);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const handleOpenTransferModal = (e) => {
        setTransferTicketModalOpen(true);
        if (typeof handleClose == "function") handleClose();
    };

    const handleOpenConfirmationModal = (e) => {
        setConfirmationOpen(true);
        if (typeof handleClose == "function") handleClose();
    };


    const handleCloseTicketWithoutFarewellMsg = async () => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "closed",
                userId: user?.id || null,
                sendFarewellMessage: false,
                amountUsedBotQueues: 0
            });

            window.dispatchEvent(new CustomEvent(TICKET_LIST_SYNC_EVENT, {
                detail: { ticketId: ticket.id, status: "closed" }
            }));

            setLoading(false);
            setCurrentTicket({ id: null, code: null });
            history.replace("/tickets");
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleExportPDF = async () => {
        setOpenTicketMessageDialog(true);
        handleCloseMenu();
    }

    const handleEnableIntegration = async () => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                useIntegration: !enableIntegration
            });
            setEnableIntegration(!enableIntegration)

            setLoading(false);
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleShowLogTicket = async () => {
        setShowTicketLogOpen(true);
    };

    const handleContactToggleDisableBot = async () => {

        const { id } = ticket.contact;


        try {
            const { data } = await api.put(`/contacts/toggleDisableBot/${id}`);
            ticket.contact.disableBot = data.disableBot;
            setDisableBot(data.disableBot)

        } catch (err) {
            toastError(err);
        }
    };

    const handleToggleContactTranslate = async () => {
        const { id } = ticket.contact;
        try {
            const { data } = await api.put(`/contacts/toggleTranslate/${id}`, {
                ticketId: ticket.id
            });
            const enabled = !!data.language;
            setContactTranslate(enabled);
            ticket.contact.language = data.language;
            toast.success(
                enabled
                    ? i18n.t("messagesList.header.buttons.translateEnabled")
                    : i18n.t("messagesList.header.buttons.translateDisabled")
            );
        } catch (err) {
            toastError(err);
        }
    };

    const handleCloseTransferTicketModal = () => {
        setTransferTicketModalOpen(false);
    };

    const handleDeleteTicket = async () => {
        try {
            await api.delete(`/tickets/${ticket.id}`);
            history.push("/tickets")
        } catch (err) {
            toastError(err);
        }
    };

    const handleSendMessage = async (id) => {
        let setting;

        try {
            setting = await getSetting({
                "column": "greetingAcceptedMessage"
            })
        } catch (err) {
            toastError(err);
        }
        const msg = `${setting.greetingAcceptedMessage}`; //`{{ms}} *{{name}}*, ${i18n.t("mainDrawer.appBar.user.myName")} *${user?.name}* ${i18n.t("mainDrawer.appBar.user.continuity")}.`;
        const message = {
            read: 1,
            fromMe: true,
            mediaUrl: "",
            body: `${msg.trim()}`,
        };
        try {
            await api.post(`/messages/${id}`, message);
        } catch (err) {
            toastError(err);
        }
    };


    const handleUpdateTicketStatus = async (e, status, userId) => {
        setLoading(true);
        try {
            const optimisticTicket = {
                ...ticket,
                status,
                userId: userId || null,
                queueId: ticket?.queueId || ticket?.queue?.id || null,
                user: userId ? { ...(ticket.user || {}), id: userId, name: user?.name } : null
            };

            if (onTicketUpdated) {
                onTicketUpdated(optimisticTicket);
            }

            const { data } = await api.put(`/tickets/${ticket.id}`, {
                status: status,
                queueId: ticket?.queueId || ticket?.queue?.id || null,
                userId: userId || null,
            });

            if (onTicketUpdated && data) {
                onTicketUpdated(data);
            }

            let setting;

            try {
                setting = await getSetting({
                    "column": "sendGreetingAccepted"
                })
            } catch (err) {
                toastError(err);
            }

            if (setting?.sendGreetingAccepted === "enabled" && (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled") && ticket.status === "pending") {
                handleSendMessage(ticket.id);
            }


            // if (isMounted.current) {
            setLoading(false);
            // }
            if (status === "open" || status === "group") {
                const updatedTicket = data || optimisticTicket;
                setCurrentTicket({ ...updatedTicket, code: "#" + status });
                setTimeout(() => {
                    history.replace(`/tickets/${updatedTicket.uuid || ticket.uuid}`);
                    setTabOpen(status)
                }, 0);

            } else {
                setCurrentTicket({ id: null, code: null })
                history.replace("/tickets");

            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleAcepptTicket = async (id) => {
        setLoading(true);
        try {
            const optimisticStatus = ticket.isGroup ? "group" : "open";
            const optimisticTicket = {
                ...ticket,
                status: optimisticStatus,
                userId: user?.id || null,
                queueId: ticket?.queueId || ticket?.queue?.id || null,
                user: { ...(ticket.user || {}), id: user?.id, name: user?.name }
            };

            if (onTicketUpdated) {
                onTicketUpdated(optimisticTicket);
            }

            const otherTicket = await api.put(`/tickets/${id}`, {
                status: ticket.isGroup ? "group" : "open",
                userId: user?.id,
                queueId: ticket?.queueId || ticket?.queue?.id || null,
            });
            if (onTicketUpdated && otherTicket?.data) {
                onTicketUpdated(otherTicket.data);
            }
            if (otherTicket.data.id !== ticket.id) {
                if (otherTicket.data.userId !== user?.id) {
                    setOpenAlert(true)
                    setUserTicketOpen(otherTicket.data.user.name)
                    setQueueTicketOpen(otherTicket.data.queue.name)
                    setTabOpen(otherTicket.isGroup ? "group" : "open")
                } else {
                    setLoading(false);
                    setTabOpen(otherTicket.isGroup ? "group" : "open")
                    setCurrentTicket({ ...otherTicket.data, code: "#" + (otherTicket.isGroup ? "group" : "open") });
                    history.replace(`/tickets/${otherTicket.data.uuid}`);
                }
            } else {
                setLoading(false);
                const updatedTicket = otherTicket?.data || optimisticTicket;
                setCurrentTicket({ ...updatedTicket, code: "#" + (ticket.isGroup ? "group" : "open") });
                setTabOpen(ticket.isGroup ? "group" : "open")
                history.replace(`/tickets/${updatedTicket.uuid || ticket.uuid}`);
            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    return (
        <>
            {openAlert && (
                <ShowTicketOpen
                    isOpen={openAlert}
                    handleClose={handleCloseAlert}
                    user={userTicketOpen}
                    queue={queueTicketOpen}
                />
            )}
            {acceptTicketWithouSelectQueueOpen && (
                <AcceptTicketWithouSelectQueue
                    modalOpen={acceptTicketWithouSelectQueueOpen}
                    onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
                    ticketId={ticket.id}
                    ticket={ticket}
                    onTicketUpdated={onTicketUpdated}
                />
            )}
            {showTicketLogOpen && (
                <ShowTicketLogModal
                    isOpen={showTicketLogOpen}
                    handleClose={(e) => setShowTicketLogOpen(false)}
                    ticketId={ticket.id}
                />
            )}
            {openTicketMessageDialog && (
                <TicketMessagesDialog
                    open={openTicketMessageDialog}
                    handleClose={() => setOpenTicketMessageDialog(false)}
                    ticketId={ticket.id}
                />
            )}
            {aiSummaryModalOpen && (
                <AiSummaryModal
                    open={aiSummaryModalOpen}
                    onClose={() => setAiSummaryModalOpen(false)}
                    ticketId={ticket.id}
                />
            )}
            {contactHistoryOpen && (
                <ContactHistoryModal
                    open={contactHistoryOpen}
                    onClose={handleCloseContactHistory}
                    contact={ticket.contact}
                    ticket={ticket}
                    allowWrite
                />
            )}
            <Dialog
                open={bitacoraCloseGuardOpen}
                onClose={() => {
                    setBitacoraCloseGuardOpen(false);
                    setResumeCloseAfterHistory(false);
                }}
                aria-labelledby="bitacora-close-guard-title"
            >
                <DialogContent>
                    <Typography id="bitacora-close-guard-title" variant="h6" gutterBottom>
                        Falta la bitácora inicial
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Este contacto aún no tiene una bitácora general. Registre el cliente, NIT o cédula y datos relevantes antes de cerrar el ticket.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setBitacoraCloseGuardOpen(false);
                        setResumeCloseAfterHistory(false);
                    }} color="default">
                        Volver al ticket
                    </Button>
                    <Button onClick={handleCreateRequiredHistory} color="primary" variant="contained">
                        Crear bitácora
                    </Button>
                </DialogActions>
            </Dialog>
            <div className={classes.actionButtons}>
                {ticket.status === "closed" && (ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                        loading={loading}
                        startIcon={<Replay />}
                        size="small"
                        onClick={e => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                        {i18n.t("messagesList.header.buttons.reopen")}
                    </ButtonWithSpinner>
                )}
                {(ticket.status === "closed" && ticket.queueId !== null) && (
                    <ButtonWithSpinner
                        startIcon={<Replay />}
                        loading={loading}
                        onClick={e => handleAcepptTicket(ticket.id)}
                    >
                        {i18n.t("messagesList.header.buttons.reopen")}
                    </ButtonWithSpinner>
                )}
                {/* <IconButton
                    className={classes.bottomButtonVisibilityIcon}
                    onClick={handleShowLogTicket}
                >
                    <Tooltip title={i18n.t("messagesList.header.buttons.logTicket")}>
                        <History />

                    </Tooltip>
                </IconButton> */}
                {(ticket.status === "open" || ticket.status === "group") && (
                    <>
                        {/* {!showSelectMessageCheckbox ? ( */}
                        <>
                            {/* <IconButton
                                className={classes.bottomButtonVisibilityIcon}
                                onClick={handleEnableIntegration}
                            >
                                <Tooltip title={i18n.t("messagesList.header.buttons.enableIntegration")}>
                                    {enableIntegration === true ? <DeviceHubOutlined style={{ color: "green" }} /> : <DeviceHubOutlined />}

                                </Tooltip>
                            </IconButton> */}

                            <IconButton
                                className={classes.bottomButtonVisibilityIcon}
                                onClick={handleToggleContactTranslate}
                            >
                                <Tooltip title={contactTranslate
                                    ? i18n.t("messagesList.header.buttons.disableTranslate")
                                    : i18n.t("messagesList.header.buttons.enableTranslate")
                                }>
                                    <TranslateIcon style={contactTranslate ? { color: "#25D366" } : {}} />
                                </Tooltip>
                            </IconButton>

                            <IconButton
                                className={classes.bottomButtonVisibilityIcon}
                                onClick={() => setAiSummaryModalOpen(true)}
                            >
                                <Tooltip title="Resumos IA">
                                    <AiSummaryIcon style={{ color: "#6B46C1" }} />
                                </Tooltip>
                            </IconButton>

                            {needsHistoryReminder ? (
                                <div
                                    className={classes.historyReminderWrapper}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => setContactHistoryOpen(true)}
                                    onKeyDown={event => {
                                        if (event.key === "Enter" || event.key === " ") {
                                            event.preventDefault();
                                            setContactHistoryOpen(true);
                                        }
                                    }}
                                >
                                    <Tooltip title="Recuerde crear la bitácora inicial de este contacto" arrow>
                                        <IconButton
                                            className={`${classes.bottomButtonVisibilityIcon} ${classes.historyReminderButton}`}
                                            onClick={event => {
                                                event.stopPropagation();
                                                setContactHistoryOpen(true);
                                            }}
                                        >
                                            <History style={{ color: "#ff9800" }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Typography className={classes.historyReminderText}>
                                        Crear bitácora
                                    </Typography>
                                </div>
                            ) : (
                            <IconButton
                                className={classes.bottomButtonVisibilityIcon}
                                onClick={() => setContactHistoryOpen(true)}
                            >
                                <Tooltip title="Bitácora del cliente">
                                    <History style={{ color: "#4FC3F7" }} />
                                </Tooltip>
                            </IconButton>
                            )}

                            <IconButton className={classes.bottomButtonVisibilityIcon}>
                                <Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
                                    <ResolveIcon
                                        // color="primary"
                                        onClick={handleClickOpen}
                                    />
                                </Tooltip>
                            </IconButton>

                            <IconButton className={classes.bottomButtonVisibilityIcon}>
                                <Tooltip title={i18n.t("tickets.buttons.returnQueue")}>
                                    <ReturnQueueIcon
                                        // color="primary"
                                        onClick={(e) => handleUpdateTicketStatus(e, "pending", null)}
                                    />
                                </Tooltip>
                            </IconButton>

                            <IconButton className={classes.bottomButtonVisibilityIcon}>
                                <Tooltip title={i18n.t("ticketsResponsive.actions.transferTicket")}>
                                    <TransferTicketIcon
                                        // color="primary"
                                        onClick={handleOpenTransferModal}
                                    />
                                </Tooltip>
                            </IconButton>
                        </>

                        {/* {showSchedules && (
                            <>
                                <IconButton className={classes.bottomButtonVisibilityIcon}>
                                    <Tooltip title={i18n.t("tickets.buttons.scredule")}>
                                        <EventIcon
                                            // color="primary"
                                            onClick={handleOpenScheduleModal}
                                        />
                                    </Tooltip>
                                </IconButton>
                            </>
                        )} */}

                        <MenuItem className={classes.bottomButtonVisibilityIcon}>
                            <Tooltip title={i18n.t("contactModal.form.chatBotContact")}>
                                <ChatHeaderSwitch
                                    size="small"
                                    checked={disableBot}
                                    onChange={() => handleContactToggleDisableBot()}
                                />
                            </Tooltip>
                        </MenuItem>



                        {confirmationOpen && (
                            <ConfirmationModal
                                title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")} #${ticket.id}?`}
                                open={confirmationOpen}
                                onClose={setConfirmationOpen}
                                onConfirm={handleDeleteTicket}
                            >
                                {i18n.t("ticketOptionsMenu.confirmationModal.message")}
                            </ConfirmationModal>
                        )}
                        {transferTicketModalOpen && (
                            <TransferTicketModalCustom
                                modalOpen={transferTicketModalOpen}
                                onClose={handleCloseTransferTicketModal}
                                ticketid={ticket.id}
                                ticket={ticket}
                            />
                        )}
                        {/* {scheduleModalOpen && (
                            <ScheduleModal
                                open={scheduleModalOpen}
                                onClose={handleCloseScheduleModal}
                                aria-labelledby="form-dialog-title"
                                contactId={contactId}
                            />
                        )} */}

                    </>
                )}
                {ticket.status === "pending" && (ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                        loading={loading}
                        size="small"
                        variant="contained"
                        onClick={e => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                        {i18n.t("messagesList.header.buttons.accept")}
                    </ButtonWithSpinner>
                )}
                {ticket.status === "pending" && ticket.queueId !== null && (
                    <ButtonWithSpinner
                        loading={loading}
                        size="small"
                        variant="contained"
                        // color="primary"
                        onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
                    >
                        {i18n.t("messagesList.header.buttons.accept")}
                    </ButtonWithSpinner>
                )}
                <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenu}
                    color="inherit"
                    style={{ paddingHorizontal: 3, paddingTop: 10 }}
                >
                    <MoreVert style={{ fontSize: 16, padding: 0 }} />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={menuOpen}
                    onClose={handleCloseMenu}
                >
                    <MenuItem onClick={handleOpenConfirmationModal}>
                        <Can
                            role={user.profile}
                            perform="ticket-options:deleteTicket"
                            yes={() => (
                                i18n.t("tickets.buttons.deleteTicket")
                            )}
                        />
                    </MenuItem>
                    <MenuItem onClick={handleEnableIntegration}>
                        {enableIntegration === true ? i18n.t("messagesList.header.buttons.disableIntegration") : i18n.t("messagesList.header.buttons.enableIntegration")}
                    </MenuItem>
                    <MenuItem onClick={handleShowLogTicket}>
                        {i18n.t("messagesList.header.buttons.logTicket")}
                    </MenuItem>
                    <MenuItem onClick={handleExportPDF}>
                        {i18n.t("ticketsList.buttons.exportAsPDF")}
                    </MenuItem>
                </Menu>
            </div>
            <>
                <Formik
                    enableReinitialize={true}
                    validationSchema={SessionSchema}
                    innerRef={formRef}
                    onSubmit={(values, actions) => {
                        setTimeout(() => {
                            actions.setSubmitting(false);
                            actions.resetForm();
                        }, 400);
                    }}
                >
                    {({ values, touched, errors, isSubmitting, setFieldValue, resetForm }) => (
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <Form>
                                <DialogContent className={classes.closeDialogContent}>
                                    <div className={classes.closeDialogHeader}>
                                        <Typography variant="h6">
                                            Resolver ticket con apoyo IA
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            Revise el resumen mas reciente antes de cerrar. Puede regenerarlo si hubo cambios al final de la conversacion.
                                        </Typography>
                                    </div>

                                    <div className={classes.closeSummaryActions}>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            onClick={handleGenerateCloseSummary}
                                            disabled={generatingCloseSummary}
                                            startIcon={generatingCloseSummary ? <CircularProgress size={16} /> : <AiSummaryIcon style={{ width: 18, height: 18 }} />}
                                        >
                                            {generatingCloseSummary ? "Generando resumen..." : "Actualizar resumen IA"}
                                        </Button>
                                    </div>

                                    {loadingCloseSummary ? (
                                        <Paper className={classes.closeSummaryEmpty} elevation={0}>
                                            <Typography variant="body2" color="textSecondary">
                                                Cargando resumen IA...
                                            </Typography>
                                        </Paper>
                                    ) : latestCloseSummary ? (
                                        <Paper className={classes.closeSummaryCard} elevation={0}>
                                            <div className={classes.closeSummaryMeta}>
                                                <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                                                    Ultimo resumen disponible
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    {latestCloseSummary?.createdAt
                                                        ? new Date(latestCloseSummary.createdAt).toLocaleString("es-CO")
                                                        : "Sin fecha"}
                                                </Typography>
                                            </div>
                                            <Typography className={classes.closeSummaryText}>
                                                {latestCloseSummary.summaryText || "No hay contenido resumido disponible."}
                                            </Typography>
                                        </Paper>
                                    ) : (
                                        <Paper className={classes.closeSummaryEmpty} elevation={0}>
                                            <Typography variant="body2" color="textSecondary">
                                                Todavia no existe un resumen IA para este ticket. Puede generarlo ahora y luego cerrar normalmente.
                                            </Typography>
                                        </Paper>
                                    )}
                                </DialogContent>
                                <DialogActions className={classes.botoes}>
                                    <Button
                                        onClick={e => handleRequestTicketClose(e, false)}
                                        style={{ background: theme.palette.primary.main, color: "white" }}
                                    >
                                        {i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
                                    </Button>

                                    <Button
                                        onClick={e => handleRequestTicketClose(e, true)}
                                        style={{ background: theme.palette.primary.main, color: "white" }}
                                    >
                                        {i18n.t("messagesList.header.dialogRatingCancel")}
                                    </Button>
                                </DialogActions>
                            </Form>
                        </Dialog>
                    )}
                </Formik>
            </>
        </>
    );
};

export default TicketActionButtonsCustom;
const TICKET_LIST_SYNC_EVENT = "ticket-list-sync";
